import { useCallback, useMemo } from 'react'
import { SequenceConfig, useKeySequences } from '~/hooks/useKeyboard'
import { isElectron } from '~/utils/common'
import { easterEggSequences } from '~/utils/easterEggUtils'

/**
 * App-level hotkeys that work throughout the entire app lifecycle
 */
export const useAppHotkeys = () => {
  const handleShowDevTools = useCallback(() => {
    if (isElectron) {
      window.electron?.send('open-devtools')
    }
  }, [])

  const handleShowPopup = useCallback(() => {
    if (isElectron) {
      window.electron?.send('toggle-popup-window')
    }
  }, [])

  const sequences = useMemo(
    (): SequenceConfig[] => [
      {
        keys: [
          { code: 'KeyP', ctrlKey: true, altKey: true, shiftKey: true },
          { code: 'KeyP', ctrlKey: true, altKey: true, shiftKey: true },
        ],
        callback: handleShowPopup,
      },
      {
        keys: [
          { code: 'KeyD', ctrlKey: true, altKey: true, shiftKey: true },
          { code: 'KeyD', ctrlKey: true, altKey: true, shiftKey: true },
        ],
        callback: handleShowDevTools,
      },
      easterEggSequences,
    ],
    [handleShowDevTools, handleShowPopup],
  )

  useKeySequences(sequences)
}
